<template>
	<nav class="sub-navigation" v-sticky>
		<ul>
			<li
				v-for="item in items"
				:key="item.key"
				:class="{'active': page === item.key}"
			>
				<a v-if="item.key === 'messages'" href="#" @click.prevent="openMessages">
					<Icon
						:icon="loadingMessages ? 'loading' : item.icon"
						:spin="loadingMessages"
					/>
					<span class="text">{{ item.text }}</span>
					<!-- TODO reload customer when messages changes? -->
					<span v-if="newMessagesCount" class="count-bubble count-bubble--left">{{ newMessagesCount}}</span>
				</a>
				<a v-else :href="item.url">
					<Icon :icon="item.icon"/>
					<span class="text">{{ item.text }}</span>
				</a>
			</li>
			<li v-if="shouldShow('logout')">
				<a href="#" @click.prevent="logout">
					<Icon icon="logout"/>
					<span class="text">Abmelden</span>
				</a>
			</li>
		</ul>
	</nav>
</template>

<script>
import Logout from "@/api/auth/Logout";
import MessagesLink from "@/vue/common/sub-navigation/MessagesLink";
import {mapActions, mapState} from "vuex";
import Icon from "@/vue/icon/Icon";
import _ from "lodash";
import {INITIATOR_APPLICANT} from "@/store/communication/conversation/messages";
import GetList from "@/api/application/job/GetList";

const ITEMS = [
	{
		key: 'jobs',
		url: '/kandidat/profil/jobs',
		icon: 'heart',
		text: 'Matches'
	},
	{
		key: 'job-edit',
		url: '/kandidat/profil/job-bearbeiten',
		icon: 'pencil',
		text: 'Jobwunsch'
	},
	{
		key: 'skills',
		url: '/kandidat/profil/kompetenzen',
		icon: 'rocket',
		text: 'Meine Skills'
	},
	{
		key: 'career',
		url: '/kandidat/profil/lebenslauf',
		icon: 'flag',
		text: 'Mein Lebenslauf'
	},
	{
		key: 'messages',
		icon: 'mail',
		text: 'Nachrichten',
		visibilityCheck: ({application}) => application?.newMessagesCount > 0
	},
	{
		key: 'employments',
		url: '/kandidat/profil/zusagen',
		icon: 'signature',
		text: 'Zusagen',
		visibilityCheck: ({application}) => application?.employmentsCount > 0
	},
	{
		key: 'sendoffs',
		url: '/kandidat/profil/verabschiedungen',
		icon: 'wave',
		text: 'Verabschiedungen',
		visibilityCheck: ({application}) => application?.sendoffsCount > 0
	},
	{
		key: 'exclusions',
		url: '/kandidat/profil/ausschluesse',
		icon: 'lock',
		text: 'Kein Interesse',
		visibilityCheck: ({application}) => application?.exclusionsCount > 0
	},
	{
		key: 'security',
		url: '/kandidat/profil/sicherheit',
		icon: 'cloud',
		text: 'Daten & Sicherheit',
	},
];
export default {

	components: {
		MessagesLink,
		Icon,
	},

	props: {
		page: {
			type: String,
			required: false,
		},
		only: {
			type: Array,
			required: false,
		},
	},

	data ()
	{
		return {
			loadingMessages: false
		};
	},

	computed: {
		...mapState('auth', [
			'application'
		]),
		newMessagesCount ()
		{
			return this.application?.newMessagesCount;
		},
		items ()
		{
			return _.filter(
				ITEMS,
				item =>
				{
					return this.shouldShow(item.key);
				}
			);
		},
	},

	methods: {
		...mapActions('communication/conversation/messages', {
			openMessagesFan: 'show'
		}),
		shouldShow (key)
		{
			const config = _.find(ITEMS, item => item.key === key);

			return (!this.only || _.includes(this.only, key))
				&& (!config?.visibilityCheck || config.visibilityCheck({ application: this.application }));
		},
		async openMessages ()
		{
			this.loadingMessages = true;

			const response = await new GetList()
				.call();

			await this.openMessagesFan({
				applicantData: {
					job: _.first(response.data),
				},
				initiator: INITIATOR_APPLICANT,
				onClose: () =>
				{
					this.$emit('close');
				}
			});

			this.loadingMessages = false;
		},
		async logout ()
		{
			try
			{
				await new Logout().call();

				location.href = '/auth/login';
			}
			catch (e)
			{

			}
		},
	}
}
</script>
